import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "discourse/templates/invites.hbs" })